import React from 'react';

// helpers
import {formatPhoneNumber} from '../../../shared/helpers';

// components
import {CardBorder} from '../../../shared/components';

// styles
import {CardContactWrapper, IconPhone} from '../ContactPage-styles';
import {LinkPrimary} from '../../../shared/styles';

// types
type Props = {
  supportPhoneNumber: string | undefined;
};

const CardPhoneNumberContact = ({supportPhoneNumber}: Props) => {
  /**
   * When the card is clicked, it redirects to the phone dialer
   */
  const onCardClick = () => {
    if (supportPhoneNumber) {
      window.location.href = `tel:${supportPhoneNumber}`;
    }
  };

  return (
    <CardBorder variant="primary">
      <CardContactWrapper
        onClick={onCardClick}
        isHoverable={supportPhoneNumber != null}>
        <IconPhone />
        {supportPhoneNumber ? (
          <LinkPrimary>{formatPhoneNumber(supportPhoneNumber)}</LinkPrimary>
        ) : (
          '-'
        )}
      </CardContactWrapper>
    </CardBorder>
  );
};

export default CardPhoneNumberContact;
